// removed by extract-text-webpack-plugin
module.exports = {"page":"_1ynNtkpmzw_TIXXfNwREQp","line":"_2S1w5GGRRNUCd9m3dFaGdG","action":"_33qldkGo4TSUT8_RRFkV2h"};


//////////////////
// WEBPACK FOOTER
// ./src/css/components/loader.css
// module id = 347
// module chunks = 0